export default __webpack_public_path__ + "static/media/Sub.Chef.LOGO1-01.11983310.jpg";